/**
 * Stage Chatbot:テキスト追加 Modal — 取代 window.prompt 的两个连续输入。
 *
 * 设计:
 * - 复用 globals.css 的 .mv2-modal-* 样式(与 ViewModal / MailV2 一致)
 * - 字段:タイトル(input) + 本文(textarea)— 与后端 create_manual_text 对齐
 * - 按钮:キャンセル / 追加する(creating 中 disabled)
 * - creating 中错误 → modal 内红框提示,不关闭
 */

import React, { useEffect, useState } from "react";

interface KnowledgeCreateModalProps {
  open: boolean;
  creating: boolean;
  error: string | null;
  onCancel: () => void;
  onCreate: (title: string, content: string) => Promise<void> | void;
}

export function KnowledgeCreateModal({
  open,
  creating,
  error,
  onCancel,
  onCreate,
}: KnowledgeCreateModalProps) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (open) {
      setTitle("");
      setContent("");
    }
  }, [open]);

  if (!open) return null;

  const canSubmit = title.trim().length > 0 && content.trim().length > 0 && !creating;

  const handleSubmit = () => {
    if (!canSubmit) return;
    onCreate(title.trim(), content);
  };

  return (
    <div
      className="mv2-modal-backdrop"
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-label="テキスト追加"
    >
      <div
        className="mv2-modal"
        style={{ width: 640 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mv2-modal-header">
          <h2>テキスト追加</h2>
          <button
            type="button"
            className="mv2-modal-close"
            onClick={onCancel}
            aria-label="閉じる"
          >
            ×
          </button>
        </div>
        <div
          className="mv2-modal-body"
          style={{ display: "flex", flexDirection: "column", gap: 14 }}
        >
          <div className="field">
            <label className="field-label">タイトル</label>
            <input
              className="input"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              maxLength={200}
              disabled={creating}
              placeholder="例: 料金プランについて"
              autoFocus
            />
          </div>

          <div className="field">
            <label className="field-label">本文</label>
            <textarea
              className="textarea"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              maxLength={100000}
              disabled={creating}
              placeholder="本文を入力してください。"
              style={{ minHeight: 220 }}
            />
          </div>

          {error && (
            <div
              style={{
                padding: 10,
                fontSize: 12,
                color: "#991b1b",
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 6,
              }}
            >
              {error}
            </div>
          )}
        </div>
        <div className="mv2-modal-footer">
          <button
            type="button"
            onClick={onCancel}
            disabled={creating}
            style={{
              padding: "6px 14px",
              fontSize: 13,
              fontWeight: 600,
              color: "#374151",
              background: "#fff",
              border: "1px solid #d1d5db",
              borderRadius: 6,
              cursor: creating ? "not-allowed" : "pointer",
              opacity: creating ? 0.5 : 1,
            }}
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!canSubmit}
            style={{
              padding: "6px 14px",
              fontSize: 13,
              fontWeight: 600,
              color: "#fff",
              background: canSubmit ? "#2563eb" : "#9ca3af",
              border: `1px solid ${canSubmit ? "#2563eb" : "#9ca3af"}`,
              borderRadius: 6,
              cursor: canSubmit ? "pointer" : "not-allowed",
            }}
          >
            {creating ? "追加中..." : "追加する"}
          </button>
        </div>
      </div>
    </div>
  );
}
